import axios from "axios";

const getLocationsApi = process.env.REACT_APP_API_URL + "/api/get-locations";
const createLocationApi =
  process.env.REACT_APP_API_URL + "/api/create-location";

/**
 * Gets the JWT token from cookies
 * @returns {string|null} The JWT token or null if not found
 */
const getAuthToken = () => {
  const cookies = document.cookie.split("; ");
  const authCookie = cookies.find((row) => row.startsWith("_auth="));
  if (authCookie) {
    return authCookie.split("=")[1];
  }
  return null;
};

const fetchLocations = async () => {
  try {
    const token = getAuthToken();
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await axios.get(getLocationsApi, {
      headers: headers,
      withCredentials: true, // Important for sending cookies if backend expects them
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Locations:", error);
    throw error;
  }
};

const addLocation = async (locationData) => {
  try {
    const response = await axios.post(createLocationApi, locationData);
    return response.data;
  } catch (error) {
    console.error("Error adding Location:", error);
    throw error;
  }
};

export { fetchLocations, addLocation };
